import React from "react";
import Styles from './styles.module.scss';
import Logo from "../_UI/logo";

import telIcon from '../../theme/assets/svg/lp_soc_tel_icon.svg';
import ytIcon from '../../theme/assets/svg/lp_soc_yt_icon.svg';
import disIcon from '../../theme/assets/svg/lp_soc_dis_icon.svg';
import {useTranslation} from "react-i18next";


const AuthFooter = () => {
    const currentYear = new Date().getFullYear();
    const { t } = useTranslation();

    return (
        <section className={`${Styles.container}`}>
            <div className={`${Styles.contentWrap} ${Styles.pageContainer}`}>
                <Logo/>
                <div className={`${Styles.socWrap}`}>
                    <div
                        className={`${Styles.socItem}`}
                        onClick={() => {
                            window.open("https://t.me/officialOMT", "_blank");
                        }}
                    >
                        <img src={telIcon} alt="Telegram"/>
                    </div>
                    <div
                        className={`${Styles.socItem}`}
                        onClick={() => {
                            window.open("https://www.youtube.com/channel/UCDx29CIHFou4lrdIDHBRmiw", "_blank");
                        }}
                    >
                        <img src={ytIcon} alt="YouTube"/>
                    </div>
                    <div
                        className={`${Styles.socItem}`}
                        onClick={() => {
                            window.open("https://discord.gg/YWMJkwkg74", "_blank");
                        }}
                    >
                        <img src={disIcon} alt="Discord"/>
                    </div>
                </div>
            </div>
            <div className={`${Styles.copyWrap} ${Styles.pageContainer}`}>
                © {currentYear} Launchpad. Powered by OMT. {t("Все права защищены")}.
            </div>
        </section>
    );
};

export default AuthFooter;